import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/website/Home'
import Episode from '@/components/episodes/Episode'
import EpisodeModal from '@/components/EpisodeModal'
import PodcastModal from '@/components/PodcastModal'
import InfoModal from '@/components/InfoModal'
import store from '@/store'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
              showModal: false
            },
            children: [
                {
                    path: 'afleveringen',
                    name: 'afleveringen',
                    component: EpisodeModal,
                    meta: {
                        showModal: true
                    }
                },
                {
                    path: 'afleveringen/:id',
                    name: 'aflevering',
                    component: Episode
                },
                {
                    path: 'podcast',
                    name: 'podcast',
                    component: PodcastModal,
                    meta: {
                        showModal: true
                    }
                },
                {
                    path: 'info',
                    name: 'info',
                    component: InfoModal,
                    meta: {
                        showModal: true
                    }
                }
            ]
        },
        { path: '*', redirect: '/' }
    ]
})
export default router

router.beforeEach((to, from, next) => {
    if (to.name === 'home' && from.name === 'aflevering') {
        store.commit('SHOW_EPISODE', false)
        setTimeout(() => {
            store.commit('SHOW_WEBSITE', true)
        }, 600)
    }
    if(to.name === 'afleveringen' || to.name === 'podcast' || to.name === 'info') {
        store.commit('SHOW_WEBSITE', true)
        store.commit('SHOW_EPISODE', false)
    }
    if(to.name === 'aflevering') {
        store.commit('SHOW_WEBSITE', false)
        store.commit('SHOW_EPISODE', true)
        store.commit('SET_INITIAL_LOAD', false)
    }
    next()
})


// WEBPACK FOOTER //
// ./src/router/index.js